import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20abstract%20composition%20with%20flowing%20silk%20fabric%20in%20deep%20crimson%20and%20warm%20gold%20tones%2C%20soft%20gradient%20background%2C%20luxurious%20cinematic%20lighting%2C%20minimal%20sophisticated%20aesthetic%2C%20ethereal%20atmosphere%2C%20fine%20art%20quality&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="大桥未久官方专区"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide leading-tight">
            大桥未久
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 opacity-90">
              官方专区
            </span>
          </h1>
          <p className="text-sm md:text-base lg:text-lg text-white/80 max-w-xl mx-auto leading-relaxed mb-8">
            汇聚全系列作品、出道历程、最新动态及粉丝必看内容，为资深爱好者提供最全面、最权威的一站式资讯平台
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap"
            >
              <i className="ri-film-line"></i>
              浏览作品全集
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/30 px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}